import React from 'react'
import { Empty, Spin } from 'antd'
import { isEmpty } from 'underscore'
import { ChartBox } from '../../../../ResultPanel/component/ChartBox'
import styles from '../../Layout/AnalyticsLayout.module.scss'
import ErrorDisplay from "../../ErrorDisplay";

const limitationMessage = 'Tidal parameters are available for Water Level (WL) (Ocean datasets) only.'

interface TidalLevelChartProps {
  tidalLevelValueImage: string
  tidalValueLinks: string[]
  supported: boolean
  isLoading: boolean
  error: string
  isOfflineDataset: boolean

}

export default function TidalLevelChart({
  tidalLevelValueImage,
  tidalValueLinks,
  supported,
  isLoading,
  error,
  isOfflineDataset
}: TidalLevelChartProps) {

  if (isOfflineDataset) {
    return (
      <ErrorDisplay
        isOfflineDataset={isOfflineDataset}
      />
    )
  }

  if (!supported) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        minHeight: '400px',
        color: '#ff4d4f',
        fontSize: '16px',
        textAlign: 'center',
        padding: '40px'
      }}>
        {limitationMessage}
      </div>
    )
  }


  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        minHeight: '400px'
      }}>
        <Spin size="large" />
      </div>
    )
  }

  return (
    <div id="Analytics-TidalLevel-Plot" className={styles.chartPointWrapper}>
      <ChartBox
        key="Tidal Level"
        title="Tidal Level"
        height={isLoading || !isEmpty(error) ? '50px' : 'auto'}
        plot={
          isLoading ? (
            <div className={styles.spinner}>
              <Spin size="large" />
            </div>
          ) : !isEmpty(error) && !error.includes('Cmems error') ? (
            <div>{error}</div>
          ) : tidalLevelValueImage ? (
            <img
              style={{
                width: '80%',
                objectFit: 'scale-down',
                maxHeight: '65vh',
                display: 'block',
                margin: '0 auto'
              }}
              src={tidalLevelValueImage}
              alt="Tidal Level"
            />
          ) : <Empty description={error.includes('Cmems error') ? "Layer not available" : "No data available"} />
        }
        dataset=""
        link={tidalValueLinks}
      />
    </div>
  )
}
